import axios from "../axiosInstance";
import {
  GetEmailNotificationsRequest,
  GetEmailNotificationsResponse,
} from "./types";

export const getEmailNotifications = async (
  params?: GetEmailNotificationsRequest,
): Promise<GetEmailNotificationsResponse> => {
  const response = await axios.get<GetEmailNotificationsResponse>(
    "/api/private/email-notifications",
    { params },
  );
  return response.data;
};
